var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBridge = function SvgBridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M6 7V3.91c-.72-.33-1.39-.73-2-1.2V7zm-2 4H2V9H0V7h2V0h2v1.43C5.8 3 8.27 4 11 4s5.2-1 7-2.57V0h2v7h2v2h-2v2h-2V9H4zm12-7.09V7h2V2.71c-.61.47-1.28.87-2 1.2M15 7V4.32c-.64.23-1.31.4-2 .52V7zm-3 0V4.96L11 5l-1-.04V7zM9 7V4.84c-.69-.12-1.36-.29-2-.52V7z"
  })));
};
export default SvgBridge;